import { i18n } from 'i18n/setupInternationalization';
import { TFunction, Trans } from 'react-i18next';
import { TransLink } from 'components/text/TransLink';
import { normalizeKey } from './localeUtils';

function internalServerError(error: any) {
  return error?.response?.status >= 500;
}

function hasErrorCode(error: any) {
  return error?.response?.data?.apiErrorCode;
}

function hasErrorMessage(error: any) {
  return error?.response?.data?.apiErrorMessage;
}

export function extractErrorMessage(error: any): string {
  if (internalServerError(error)) {
    return 'common.apiResponses.internalServerError';
  }
  if (hasErrorCode(error)) {
    return `common.apiErrorCodes.${error?.response?.data?.apiErrorCode}`;
  }
  if (hasErrorMessage(error)) {
    return error?.response?.data?.apiErrorMessage;
  }
  return 'common.apiResponses.invalidRequest';
}

export function getErrorMessage({
  apiErrorCode,
  apiErrorMessage,
  baseKey,
  t,
}: {
  apiErrorCode?: string;
  apiErrorMessage?: string;
  baseKey: string;
  t: TFunction;
}): React.ReactNode {
  if (apiErrorCode && i18n.exists(`${baseKey}${apiErrorCode}`)) {
    return (
      <Trans
        i18nKey={normalizeKey(`${baseKey}${apiErrorCode}`) as any}
        components={{
          booking_dot_com_eligibility_link: (
            <TransLink
              target="_blank"
              data-testid="booking-dot-com-eligibility-link"
              href="https://developers.booking.com/connectivity/docs/request-to-book/eligibility"
              rel="noreferrer"
            />
          ),
        }}
      />
    );
  }

  return apiErrorMessage || t('common.apiResponses.internalServerError');
}
